import { Routes } from '@angular/router';
import { CheckMobileGuard } from './check-mobile.guard';
import { PagesGuard } from './shared/guard/pages.guard';

export const routes: Routes = [
  {
    path: 'etf/:id',
    pathMatch: 'full',
    loadChildren: () =>
      import('./modules/etf-overview/etf-overview.routes').then(
        (m) => m.ETF_OVERVIEW_ROUTES,
      ),
  },
  {
    path: 'etf-details/:id',
    pathMatch: 'full',
    loadChildren: () =>
      import('./modules/etf-overview/etf-overview.routes').then(
        (m) => m.ETF_OVERVIEW_ROUTES,
      ),
  },
  {
    path: 'stock/:id',
    pathMatch: 'full',
    loadChildren: () =>
      import('./modules/stock-overview/stock-overview.routes').then(
        (m) => m.STOCK_OVERVIEW_ROUTES,
      ),
  },
  {
    path: 'authentication',
    loadChildren: () =>
      import('./authentication/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'pages',
    loadChildren: () =>
      import('./pages/pages.routes').then((m) => m.PAGES_ROUTES),
    canActivate: [PagesGuard, CheckMobileGuard],
  },
  {
    path: 'thankyou',
    loadComponent: () =>
      import('./pages/thankyou/thankyou.component').then(
        (m) => m.ThankyouComponent,
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./cabinet/cabinet-shell.routes').then(
        (m) => m.CABINET_SHELL_ROUTES,
      ),
  },
];
